module.exports = __webpack_public_path__ + "img/yellow_box.a9d66547.png";